import React from "react";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { DroppableSettingsBasket } from "../draggable/DroppableSettingsBasket";

interface TableSettingsProps {
  defaults: any[];
  columns: any[];
  selectedColumns: any[];
  defaultLimit: number;
  tableSettingsDiv: string;
  onDragEnd: (dragObject: DropResult) => void;
}

export const TableSettings: React.FC<TableSettingsProps> = ({
  defaults,
  columns,
  defaultLimit,
  tableSettingsDiv,
  selectedColumns,
  onDragEnd,
}) => {
  const allColumnsDiv = "flex flex-wrap px-1 text-center min-h-11/12";

  return (
    <div className={tableSettingsDiv}>
      <DragDropContext onDragEnd={onDragEnd}>
        <DroppableSettingsBasket
          title={"selectedColumns"}
          id='droppableColumnsSelected'
          wrap={false}
          columns={selectedColumns}
        />
        <DroppableSettingsBasket
          title={"allcolumns"}
          id='droppableColumnsAll'
          divStyle={allColumnsDiv}
          wrap={true}
          columns={columns}
        />
      </DragDropContext>
    </div>
  );
};

export default TableSettings;
